import type { ReactNode } from "react";

import { useOverview } from "@/hooks/queries";

import { FreshnessPill } from "./FreshnessPill";
import { GlobalSearch } from "./GlobalSearch";
import { ScopeSwitcher } from "./ScopeSwitcher";

// Global top bar: search (stub) + a freshness pill driven by the overview endpoint's meta. The
// brand block lives in the shell grid's "brand" cell. One canonical layout — no persona switcher.
export const TopBar = (): ReactNode => {
  const overview = useOverview();
  return (
    <div className="topbar">
      <ScopeSwitcher />
      <GlobalSearch />
      <div className="topbar-spacer" />
      <FreshnessPill meta={overview.data?.meta} />
    </div>
  );
};
